import * as React from "react";
function SvgGraphArrow(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="none"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={2}
        stroke="currentColor"
        d="M4 17v8M10 15v10M16 11v14M22 13v12M28 13v12"
      />
      <path
        fill="none"
        strokeMiterlimit={10}
        strokeWidth={2}
        stroke="currentColor"
        d="M27.47 3.77L21 7l-6-3L3 9"
      />
      <path d="M23.66 2.83l3.41 1.13-1.14 3.42 1.93-.97L29 3l-3.41-1.14-1.93.97z" />
      <path
        fill="none"
        strokeMiterlimit={10}
        strokeWidth={2}
        stroke="currentColor"
        d="M0 29h32"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgGraphArrow);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
